import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function ProductCTA({
  title = "Der passende Systemfit entsteht nicht durch Raten.",
  text = "Lassen Sie uns prüfen, welches Systemprofil zu Ihrem Standort, Ihrer Fläche, Ihrer Zielgruppe und Ihrer Customer Journey passt.",
  primaryLabel = "Standortpotenzial prüfen",
  primaryHref = "/standort-pruefen",
  secondaryLabel = "Erstgespräch anfragen",
  secondaryHref = "/kontakt",
}) {
  return (
    <section className="border-t border-[rgba(255,255,255,0.08)] relative overflow-hidden">
      <div className="absolute inset-0 grid-overlay opacity-30" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="overline mb-4">Nächster Schritt</div>
        <h2 className="font-display text-3xl md:text-5xl uppercase leading-[1.05] max-w-4xl">
          {title}
        </h2>
        <p className="text-[#AEB7B7] mt-6 max-w-2xl leading-relaxed">{text}</p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to={primaryHref} className="btn-primary" data-testid="product-cta-bottom-primary">
            {primaryLabel} <ArrowUpRight size={16} strokeWidth={1.5} />
          </Link>
          <Link to={secondaryHref} className="btn-secondary" data-testid="product-cta-bottom-secondary">
            {secondaryLabel}
          </Link>
        </div>
      </div>
    </section>
  );
}
